<div [ngClass]="cardClasses" (mouseenter) = "onMouseEnter()" (mouseleave)="onMouseLeave()">

    <p>{{title}}</p>

</div>